import { Node, mergeAttributes } from '@tiptap/core';

function sizeLabel(bytes: number): string {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)}MB`;
}

/**
 * 첨부 파일 블록 — 이미지가 아닌 파일을 이름·크기와 함께 내려받는 줄로 보여 준다.
 * 바이트는 서버에 있고 문서에는 주소만 남는다.
 */
export const FileAttachment = Node.create({
  name: 'fileAttachment',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      url: { default: '' },
      name: { default: '' },
      size: { default: 0 },
    };
  },

  parseHTML() {
    return [{ tag: 'a[data-file-attachment]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'a',
      mergeAttributes(HTMLAttributes, {
        'data-file-attachment': '',
        href: node.attrs.url,
        download: node.attrs.name,
        target: '_blank',
        rel: 'noopener noreferrer',
      }),
      `📎 ${node.attrs.name} · ${sizeLabel(node.attrs.size)}`,
    ];
  },

});
